import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { endPoint } from "constants/server/api";
import { http } from "utils/http";
var authHeaders = function(lockToken) {
    return _object_spread({
        Authorization: "Bearer ".concat(localStorage.getItem("accessToken"))
    }, lockToken && {
        "x-product-check-lock-token": lockToken
    });
};
var unwrap = function(response) {
    var _response_data;
    var _response_data_data;
    return (_response_data_data = response === null || response === void 0 ? void 0 : (_response_data = response.data) === null || _response_data === void 0 ? void 0 : _response_data.data) !== null && _response_data_data !== void 0 ? _response_data_data : response === null || response === void 0 ? void 0 : response.data;
};
export var productCheckApi = {
    logs: function() {
        var _ref = _async_to_generator(function(reservationId) {
            var page, pageSize;
            var _arguments = arguments;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        page = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : 1, pageSize = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : 10;
                        return [
                            4,
                            http.get(endPoint.PRODUCT_CHECK_LOGS(reservationId), {
                                headers: authHeaders(),
                                params: {
                                    page: page,
                                    pageSize: pageSize
                                }
                            })
                        ];
                    case 1:
                        return [
                            2,
                            unwrap.apply(void 0, [
                                _state.sent()
                            ])
                        ];
                }
            });
        });
        return function(reservationId) {
            return _ref.apply(this, arguments);
        };
    }(),
    acquire: function() {
        var _ref = _async_to_generator(function(reservationId) {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            http.post(endPoint.PRODUCT_CHECK_LOCK(reservationId), {}, {
                                headers: authHeaders()
                            })
                        ];
                    case 1:
                        return [
                            2,
                            unwrap.apply(void 0, [
                                _state.sent()
                            ])
                        ];
                }
            });
        });
        return function(reservationId) {
            return _ref.apply(this, arguments);
        };
    }(),
    heartbeat: function() {
        var _ref = _async_to_generator(function(reservationId, lockToken) {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            http.post(endPoint.PRODUCT_CHECK_HEARTBEAT(reservationId), {}, {
                                headers: authHeaders(lockToken)
                            })
                        ];
                    case 1:
                        return [
                            2,
                            unwrap.apply(void 0, [
                                _state.sent()
                            ])
                        ];
                }
            });
        });
        return function(reservationId, lockToken) {
            return _ref.apply(this, arguments);
        };
    }(),
    release: function() {
        var _ref = _async_to_generator(function(reservationId, lockToken) {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            http.post(endPoint.PRODUCT_CHECK_RELEASE(reservationId), {}, {
                                headers: authHeaders(lockToken)
                            })
                        ];
                    case 1:
                        return [
                            2,
                            unwrap.apply(void 0, [
                                _state.sent()
                            ])
                        ];
                }
            });
        });
        return function(reservationId, lockToken) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateQuantity: function() {
        var _ref = _async_to_generator(function(reservationId, lockToken, payload) {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            http.post(endPoint.PRODUCT_CHECK_QUANTITY(reservationId), payload, {
                                headers: authHeaders(lockToken)
                            })
                        ];
                    case 1:
                        return [
                            2,
                            unwrap.apply(void 0, [
                                _state.sent()
                            ])
                        ];
                }
            });
        });
        return function(reservationId, lockToken, payload) {
            return _ref.apply(this, arguments);
        };
    }(),
    videoResult: function() {
        var _ref = _async_to_generator(function(reservationId, lockToken, payload) {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            http.post(endPoint.PRODUCT_CHECK_VIDEO_RESULT(reservationId), payload, {
                                headers: authHeaders(lockToken)
                            })
                        ];
                    case 1:
                        return [
                            2,
                            unwrap.apply(void 0, [
                                _state.sent()
                            ])
                        ];
                }
            });
        });
        return function(reservationId, lockToken, payload) {
            return _ref.apply(this, arguments);
        };
    }(),
    complete: function() {
        var _ref = _async_to_generator(function(reservationId, lockToken) {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            http.post(endPoint.PRODUCT_CHECK_COMPLETE(reservationId), {}, {
                                headers: authHeaders(lockToken)
                            })
                        ];
                    case 1:
                        return [
                            2,
                            unwrap.apply(void 0, [
                                _state.sent()
                            ])
                        ];
                }
            });
        });
        return function(reservationId, lockToken) {
            return _ref.apply(this, arguments);
        };
    }()
};
